import cmsBharatpurPDF from "../collegesData/Clgofmedicalsciencesbharatpur.pdf";
import NepalMedicalclg from "../collegesData/NepalMedicalclg.pdf";
import NepalgunjMedicalcollege from "../collegesData/NepalgunjMedicalcollege.pdf";
import KathmanduUniversity from "../collegesData/KathmanduUniversity.pdf";
import Patanacademyofhealth from "../collegesData/Patanacademyofhealth.pdf";
import NobelMedicalclg from "../collegesData/NobelMedicalclg.pdf";
import NationalMedicalclg from "../collegesData/NationalMedicalclg.pdf";
import LumbiniMedicalclg from "../collegesData/LumbiniMedicalclg.pdf";
import KathmanduMedicalclg from "../collegesData/KathmanduMedicalclg.pdf";
import Kistmedicalclg from "../collegesData/Kistmedicalclg.pdf";
import JanakiMedicalclg from "../collegesData/JanakiMedicalclg.pdf";
import Gandakimedicalclgteachinghospital from "../collegesData/Gandakimedicalclgteachinghospital.pdf";
import Devdahamedicalclg from "../collegesData/Devdahamedicalclg.pdf";
import BPKoiralaInstitute from "../collegesData/BPKoiralaInstitute.pdf";
import BiratMedicalCollegeFeestructure from "../collegesData/BiratMedicalCollegeFeestructure.pdf";
import ChitwanMedicalclg from "../collegesData/ChitwanMedicalclg.pdf";
import Karnali from "../collegesData/KarnaliAcademyOfHealthSciencesJumlaNepal.pdf";
import ManipalPokharaCollegeofMedicalScience from "../collegesData/ManipalPokharaCollegeofMedicalScience.pdf";
import UniversalCollegeOfMedicalSciences from "../collegesData/UniversalCollegeOfMedicalSciences.pdf";

export const nepalcollege = [
 {
  id: "1",
  universityDescription: `The College of Medical Sciences (CMS) in Bharatpur, Chitwan District, Nepal, stands as a prominent institution dedicated to medical education and healthcare services. Established on August 8, 1993, under the visionary leadership of Mr. Nagender K. Pampati, CMS has evolved into a center of excellence in medical education, research, and patient care.The College of Medical Sciences (CMS) in Bharatpur, Chitwan District, Nepal, stands as a prominent institution dedicated to medical education and healthcare services. Established on August 8, 1993, under the visionary leadership of Mr. Nagender K. Pampati, an MBA graduate from Boston, USA, CMS has evolved into a center of excellence in medical education, research, and patient care.  <br/><br/>

<strong>Vision and Mission</strong>  <br/>
CMS envisions functioning as an independent center of excellence committed to delivering high-quality specialized healthcare services and conducting research on local health issues for the holistic development of community services and medical education. Its mission encompasses promoting and preserving the highest values and ethics in education to produce medical and paramedical professionals of global standards, creating a center of excellence in medical education, and providing modern facilities with state-of-the-art equipment for excellent specialized healthcare in the region.
 <br/><br/>

<strong>Accreditations and Affiliations</strong>  <br/>

The college is affiliated with Kathmandu University and is fully recognized by the Nepal Medical Council. It has received accreditations from esteemed international bodies, including the General Medical Council of Great Britain, the Educational Commission for Foreign Medical Graduates (ECFMG) in the USA, and the Sri Lankan Medical Council. Additionally, CMS is listed in the World Health Organization's World Directory of Medical Schools, underscoring its global recognition.  `,
  collegename: "College of Medical Sciences Bharatpur",
  established: "1993-08-08",
  collegetype: "Private",
  location: "Nepal ",
  approval: "Nepal Medical Council",
  address: "Bharatpur, Chitwan District, Nepal",
  state: "Chitwan District",
  city: "Bharatpur",
  affiliatedby: "Kathmandu University",
  collegecategory: "Medical",
  pdf: cmsBharatpurPDF,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "4.5 years + 1 year internship",
    tuitionFee: "25,00,000/- ", // Research needed for specific tuition data
   },
   {
    course: "BDS",
    branch: "Bachelor of Dental Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "4 years + 1 year internship", // Research needed for specific duration data
    tuitionFee: "15,00,000/-", // Research needed for specific tuition data
   },
   {
    course: "B.Sc. Nursing",
    branch: null, // Research needed for specific Branch data.
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "MD/MS",
    branch: "Various pre-clinical and clinical disciplines",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "DM/M.Ch.",
    branch:
     "Cardiology, Neurology, Nephrology, Urology, Cardiothoracic & Vascular Surgery, Neurosurgery, and Gastroenterology",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: "http://www.cmsnepal.edu.np/", // added website from research.
  mail: null, // Research needed for official email
  image1:
   "https://www.hamrodoctor.com/image.php?src=/uploads/hospitals/580c869210590.jpg&w=1000", // Image URLs or base64 strings would need to be added
  image2:
   "https://cmsnepal.edu.np/wp-content/uploads/2018/06/final-logo-01.png", // Image URLs or base64 strings would need to be added
 },
 {
  id: "2",
  universityDescription: `Nepal Medical College (NMC) is one of Nepal's leading medical institutions, dedicated to providing high-quality medical education, healthcare services, and research opportunities. Established in 1997, NMC is located in Jorpati, Kathmandu, and has become a preferred destination for students aspiring to pursue medical education in Nepal. Affiliated with Kathmandu University, the college offers undergraduate and postgraduate programs in medicine, nursing, and allied health sciences.  

<br/><br/>
<strong>Nepal Medical College</strong>  
<br/>
 
<strong>Introduction</strong>  
<br/>  
<p>Nepal Medical College (NMC) is one of Nepal's leading medical institutions, dedicated to providing high-quality medical education, healthcare services, and research opportunities. Established in 1997, NMC is located in Jorpati, Kathmandu, and has become a preferred destination for students aspiring to pursue medical education in Nepal. Affiliated with Kathmandu University, the college offers undergraduate and postgraduate programs in medicine, nursing, and allied health sciences.</p>  

<p>The college is known for its excellent infrastructure, experienced faculty, and state-of-the-art teaching hospital. Over the years, NMC has contributed significantly to Nepal's healthcare system by producing competent and skilled medical professionals.</p>  
<br/>  

<strong>Location and Campus</strong>  
<br/>  
<p>Nepal Medical College is situated in a peaceful and serene environment in Jorpati, on the outskirts of Kathmandu. The campus is surrounded by beautiful hills, providing an ideal atmosphere for learning and research. The college has a well-planned infrastructure with academic buildings, laboratories, hostels, a library, and a hospital.</p>  

<p>The college’s location is also advantageous because it is easily accessible from different parts of Kathmandu while maintaining a calm environment conducive to medical studies. The college campus is equipped with modern facilities to enhance the overall learning experience of students.</p>  
<br/>  

<strong>Affiliation and Accreditation</strong>  
<br/>  
<p>Nepal Medical College is affiliated with Kathmandu University, one of Nepal’s most prestigious educational institutions. The college is recognized by the Nepal Medical Council (NMC), ensuring that its degrees are valid and accepted in Nepal and beyond.</p>  

<p>The college's courses are designed according to the guidelines set by the Nepal Medical Council, and graduates are eligible to appear for medical licensing examinations in Nepal and other countries, making it an attractive choice for both local and international students.</p>  
<br/>  

<strong>Courses and Programs</strong>  
<br/>  

<p>Nepal Medical College offers a variety of medical and healthcare programs, catering to different levels of medical education. Some of the main programs offered by the college include:</p>  
<br/>  

<strong>Undergraduate Programs</strong>  
<br/>  

<strong>1. MBBS (Bachelor of Medicine, Bachelor of Surgery)</strong>  
<br/>  

<ul>
<li><strong>Duration:</strong> 5.5 years (including a 1-year internship)</li>  
<li><strong>Curriculum:</strong> The MBBS program follows a well-structured syllabus, covering basic sciences, clinical sciences, and practical training in hospitals.</li>  
<li><strong>Eligibility:</strong> Students must have completed their higher secondary education (10+2) with science subjects (Biology, Chemistry, and Physics) and must qualify in the entrance examination conducted by Kathmandu University.</li>  
</ul>
`,
  collegename: "Nepal Medical College",
  established: "1997",
  collegetype: "Private",
  location: "Nepal ",
  approval: "Nepal Medical Council (NMC)",
  address: "Jorpati, Kathmandu, Nepal",
  state: "Kathmandu",
  city: "Kathmandu",
  affiliatedby: "Kathmandu University",
  collegecategory: "Medical",
  pdf: NepalMedicalclg,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "5.5 years (including a 1-year internship)",
    tuitionFee: "50,00,000/-", // Research needed for specific tuition data
   },
   {
    course: "BSc Nursing",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "4 years",
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "MD/MS",
    branch:
     "Various fields such as Internal Medicine, Surgery, Pediatrics, Orthopedics, Gynecology, and more.",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "3 years",
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "MSc Nursing",
    branch: "Community Health Nursing, Pediatric Nursing, and more.",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "2 years",
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: "http://nmc.edu.np/", // added website from research.
  mail: null, // Research needed for official email
  image1:
   "https://admin.nmcth.edu/upload/images/why-choose-us/2024/05/08/17151738710F9A9847.JPG", // Image URLs or base64 strings would need to be added
  image2:
   "https://admin.nmcth.edu/upload/images/settings/1693742098nmcLogo.png", // Image URLs or base64 strings would need to be added
 },
 {
  id: "3",
  universityDescription: `Nepalgunj Medical College (NGMC) is one of the most reputed private medical colleges in Nepal, dedicated to providing quality medical education and healthcare services. Established in the late 1990s, NGMC is affiliated with Kathmandu University and is recognized by the Nepal Medical Council (NMC), as well as various international medical councils, allowing its graduates to pursue further studies or practice medicine both within Nepal and abroad.<br/><br/>
   <strong>Nepalgunj Medical College (NGMC): A Comprehensive Overview</strong>  
<br/><br/>

<strong>Introduction</strong>  
<br/>  
<p>Nepalgunj Medical College (NGMC) is one of the most reputed private medical colleges in Nepal, dedicated to providing quality medical education and healthcare services. Established in the late 1990s, NGMC is affiliated with Kathmandu University and is recognized by the Nepal Medical Council (NMC), as well as various international medical councils, allowing its graduates to pursue further studies or practice medicine both within Nepal and abroad.</p>  
<br/>

<strong>Location and Campus Infrastructure</strong>  
<br/>  
<p>NGMC has two main campuses: the academic complex located at Chisapani, Banke, and the hospital complex situated in Nepalgunj city, about 12 kilometers away. Chisapani, being on the outskirts, offers a serene, pollution-free environment ideal for academic pursuits, while the hospital in Nepalgunj provides students with real-time exposure to a large variety of clinical cases and practical training.</p>  

<p>The Chisapani campus is well-equipped with modern academic infrastructure including lecture halls with audio-visual aids, dissection halls, modern laboratories, computer and internet facilities, a library with a vast collection of medical literature, and various departments for pre-clinical and para-clinical subjects. The campus also includes hostels, staff quarters, a canteen, a gymnasium, and recreational facilities.</p>  
<br/>

<strong>Academic Programs</strong>  
<br/>  
<p>Nepalgunj Medical College offers a range of undergraduate and postgraduate programs. The most prominent is the MBBS (Bachelor of Medicine, Bachelor of Surgery) program, which follows the curriculum laid out by Kathmandu University and is designed to be completed in five and a half years, including a one-year compulsory internship.</p>  

<p>In addition to MBBS, NGMC also offers Bachelor in Nursing (BN), B.Sc. Nursing, and Postgraduate MD/MS programs in various specialties such as Internal Medicine, Surgery, Pediatrics, Obstetrics and Gynecology, Anesthesiology, and others. The college also runs paramedical courses like Lab Technology and Pharmacy.</p>  
<br/>

<strong>Curriculum and Teaching Methods</strong>  
<br/>  
<p>The curriculum at NGMC is designed to combine theoretical knowledge with practical skills, community orientation, and professional development. The teaching methodology includes lectures, group discussions, case studies, laboratory work, clinical postings, seminars, and interactive sessions. Special emphasis is laid on Problem-Based Learning (PBL) and Evidence-Based Medicine (EBM) to ensure students develop analytical and clinical reasoning skills.</p>  

<p>The students begin with basic sciences like Anatomy, Physiology, and Biochemistry in the first two years, followed by subjects like Pathology, Pharmacology, Microbiology, and Community Medicine in the third year. Clinical rotations in departments such as Medicine, Surgery, Pediatrics, and Obstetrics and Gynecology commence in the later years, with hands-on training in patient care under experienced faculty.</p>  
<br/>

<strong>Faculty and Staff</strong>  
<br/>  
<p>NGMC boasts a team of highly qualified and experienced faculty members who are experts in their respective fields. The teachers are not only involved in teaching but also actively engaged in research, publications, and continuous medical education (CME) programs. The teaching staff maintain a friendly and supportive relationship with students, fostering a positive academic environment. Faculty development programs are frequently conducted to ensure the teaching staff remain updated with the latest medical knowledge and pedagogy.</p>  
<br/>

<strong>Affiliated Teaching Hospital</strong>  
<br/>  
<p>The Nepalgunj Medical College Teaching Hospital (NGMCTH) located in Nepalgunj is a multi-specialty tertiary care hospital with a capacity of over 700 beds. It is fully equipped with modern diagnostic and therapeutic tools such as CT scan, MRI, ICU, NICU, operating theatres, and specialized clinics. The hospital serves as the main clinical training site for medical students, exposing them to a wide variety of medical and surgical conditions.</p>  

<p>The hospital serves a large population from Nepalgunj, the Terai region, and even patients from nearby Indian states like Uttar Pradesh and Bihar due to its proximity to the border. This ensures that students have ample opportunities to observe and learn from real-world medical scenarios.</p>  
<br/>

<strong>Student Life and Facilities</strong>  
<br/>  
<p>Student life at NGMC is dynamic and culturally rich. Students from across Nepal, India, and other countries come to study here, creating a diverse and vibrant campus environment. The hostels are clean and secure, with separate facilities for boys and girls. The hostel mess provides hygienic and nutritious food.</p>  

<p>Besides academics, students are encouraged to participate in extracurricular activities such as sports, cultural events, debate competitions, medical conferences, and community outreach programs. Annual college festivals and inter-college sports meets are organized regularly, promoting camaraderie, leadership, and stress relief among students.</p>  

<p>The college also supports various student organizations, including the student union, social clubs, and medical associations, allowing students to express themselves, develop organizational skills, and contribute to society.</p>  
<br/>

<strong>Research and Development</strong>  
<br/>  
<p>NGMC encourages research activities among students and faculty members. Research is integrated into the curriculum, and students are guided to undertake research projects during their course. The institution also organizes medical conferences, journal clubs, and workshops to enhance academic exposure. The college publishes its own journal, where students and faculty can contribute articles and research findings.</p>  
<br/>

<strong>Community Services and Outreach</strong>  
<br/>  
<p>One of the hallmarks of NGMC is its strong emphasis on community-based education and service. Regular health camps, vaccination drives, awareness programs, and rural health checkups are conducted as part of the curriculum. These activities instill a sense of social responsibility in the students and help bridge the healthcare gap in underserved areas.</p>  
<br/>

<strong>International Recognition and Future Opportunities</strong>  
<br/>  
<p>Nepalgunj Medical College is recognized by several international medical councils such as the Medical Council of India (MCI), Sri Lanka Medical Council (SLMC), WHO, and others. This global recognition makes it easier for NGMC graduates to appear for international medical licensing exams like USMLE (USA), PLAB (UK), and FMGE (India).</p>  

<p>Graduates of NGMC have a strong track record of success both in Nepal and abroad. Many alumni have gone on to pursue post-graduate studies in renowned institutions or practice medicine in developed countries after clearing necessary licensing exams.</p>  
<br/>

<strong>Admission Process and Eligibility</strong>  
<br/>  
<p>Admission to NGMC's MBBS program is based on academic merit and entrance exams. Students must have completed their 10+2 or equivalent education with Physics, Chemistry, and Biology as core subjects, and must meet the eligibility criteria set by Kathmandu University and the Medical Education Commission of Nepal. Foreign students, especially from India, are also admitted through a similar process, and the college provides guidance on visa and admission formalities.</p>  
<br/>

<strong>Vision and Mission</strong>  
<br/>  
<p>Nepalgunj Medical College's mission is to produce competent, compassionate, and community-oriented medical professionals who can contribute to the health sector both nationally and globally. The college envisions becoming a center of excellence in medical education, research, and healthcare services in South Asia.</p>
`,
  collegename: "Nepalgunj Medical College",
  established: "Late 1990s",
  collegetype: "Private",
  location: "Nepal /Suburban",
  approval: "Nepal Medical Council (NMC)",
  address: "Chisapani, Banke (academic complex) & Nepalgunj (hospital complex)",
  state: "Banke",
  city: "Nepalgunj",
  affiliatedby: "Kathmandu University",
  collegecategory: "Medical",
  pdf: NepalgunjMedicalcollege,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "5.5 years (including a 1-year internship)",
    tuitionFee: "55,31,250/-", // Research needed for specific tuition data
   },
   {
    course: "BN",
    branch: "Bachelor in Nursing",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "B.Sc. Nursing",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "MD/MS",
    branch:
     "Various specialties such as Internal Medicine, Surgery, Pediatrics, Obstetrics and Gynecology, Anesthesiology, and others.",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Lab Technology",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Pharmacy",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: "http://www.ngmc.edu.np/", // added website from research.
  mail: null, // Research needed for official email
  image1:
   "https://dreammbbs.in/wp-content/uploads/2024/02/Nepalgunj-Medical-College.webp", // Image URLs or base64 strings would need to be added
  image2: "https://img.jobsnepal.com/logos/10634_Picture1.jpg", // Image URLs or base64 strings would need to be added
 },
 {
  id: "4",
  universityDescription: `
   <strong>Kathmandu University (KU)</strong>
<br/><br/>

<strong>Introduction</strong>
<br/>
<p>Kathmandu University (KU), established in 1991, is one of Nepal’s most prestigious and pioneering autonomous public institutions of higher education. Situated in the serene hills of Dhulikhel, Kavrepalanchok District, about 30 kilometers east of the capital city, Kathmandu, the university offers a peaceful and intellectually stimulating environment for students. With a strong commitment to quality education, innovation, and sustainable development, Kathmandu University has grown steadily over the years and continues to lead the academic landscape of Nepal with its progressive vision.</p>
<br/>

<strong>Foundation and Vision</strong>
<br/>
<p>Kathmandu University was established with a mission to provide quality education and foster academic excellence in Nepal. It was founded through the efforts of a team of visionaries led by Professor Dr. Suresh Raj Sharma, the university's first Vice-Chancellor. The goal was to create an institution that could stand as an alternative to the traditional model of higher education in the country. Since its inception, KU has emphasized the importance of autonomy, academic freedom, and international collaboration.</p>

<p>The university envisions becoming a world-class institution that prepares leaders capable of addressing the challenges of a changing world. It aims to instill in its students not just academic knowledge, but also a strong sense of ethics, responsibility, and global citizenship.</p>
<br/>

<strong>Campus and Infrastructure</strong>
<br/>
<p>The main campus of Kathmandu University in Dhulikhel is renowned for its scenic beauty and tranquil atmosphere. Nestled in the hills and surrounded by lush greenery, the campus provides an ideal setting for learning and research. The infrastructure is modern and purpose-built, featuring well-equipped laboratories, spacious classrooms, libraries, seminar halls, and hostels.</p>

<p>Over the years, KU has developed satellite campuses and collaborative centers across Nepal to expand its reach and impact. These include campuses in Patan, Hattiban, Banepa, and partnerships with various national and international institutions.</p>
<br/>

<strong>Academic Structure</strong>
<br/>
<p>Kathmandu University operates through its seven schools:</p>
<ul>
<li>School of Science</li>
<li>School of Engineering</li>
<li>School of Management</li>
<li>School of Arts</li>
<li>School of Education</li>
<li>School of Medical Sciences</li>
<li>School of Law</li>
</ul>

<p>Each school offers undergraduate, graduate, and postgraduate programs that are designed to meet both national and international standards. The curricula are research-oriented and updated regularly to reflect advancements in global knowledge and industry requirements.</p>

<p>For example, the School of Engineering offers programs in Civil, Electrical and Electronics, Mechanical, Computer, and Geomatics Engineering. The School of Science offers programs in Biotechnology, Pharmacy, Environmental Science, and Applied Physics. The School of Medical Sciences (KUSMS) is highly reputed and has affiliated colleges across the country, training future doctors, nurses, and health professionals.</p>
<br/>

<strong>Quality of Education</strong>
<br/>
<p>Kathmandu University is known for maintaining a high standard of education. Admission to KU is competitive, with entrance examinations and interviews ensuring that only deserving and dedicated students are enrolled. The faculty comprises qualified and experienced professionals, many of whom have received advanced degrees and training from international universities.</p>

<p>The university emphasizes interactive teaching methods, continuous assessment, and a blend of theoretical and practical learning. Students are encouraged to participate in research projects, internships, community service, and extracurricular activities to ensure their holistic development.</p>
<br/>

<strong>Research and Innovation</strong>
<br/>
<p>One of Kathmandu University’s defining features is its strong emphasis on research and innovation. KU supports faculty and student-led research in diverse fields, including science, engineering, health, environment, and social sciences. It has established several research centers and laboratories that collaborate with national and international institutions.</p>

<p>The university also promotes innovation through its incubation centers and entrepreneurship programs. These initiatives help students develop their own startups, engage in problem-solving for real-world challenges, and contribute to national development.</p>
<br/>

<strong>International Collaboration</strong>
<br/>
<p>KU has cultivated partnerships with numerous universities and organizations around the world. These collaborations have facilitated student exchange programs, joint research projects, faculty development, and knowledge sharing. Countries such as Germany, South Korea, Japan, the United States, China, and several European nations have academic ties with Kathmandu University.</p>

<p>Students benefit from exposure to global educational practices and opportunities to study or intern abroad. The university also hosts international conferences, seminars, and workshops, further enriching the academic environment.</p>
<br/>

<strong>Student Life</strong>
<br/>
<p>Life at Kathmandu University extends beyond academics. The campus hosts a vibrant community of students from across Nepal and abroad. Student clubs, cultural events, sports competitions, and social service projects provide ample opportunities for students to engage, express, and evolve.</p>

<p>The university organizes an annual festival called "KU Fest," which includes cultural performances, debates, exhibitions, and musical concerts. This celebration of diversity and talent fosters a sense of belonging and joy among students.</p>

<p>The university also pays attention to students’ physical and mental well-being. Sports facilities, counseling services, and health care units are available on campus to support students in all aspects of their lives.</p>
<br/>

<strong>Social Impact and Sustainability</strong>
<br/>
<p>Kathmandu University is deeply committed to sustainable development and community engagement. Through its projects in renewable energy, water management, health care, and education, KU has made tangible contributions to rural development in Nepal.</p>

<p>The university promotes environmental sustainability on campus and incorporates eco-friendly practices in its operations. It encourages students and faculty to take part in activities that promote conservation, awareness, and responsible living.</p>

<p>KU's programs often include community service components, wherein students work on projects in rural and underdeveloped regions, applying their knowledge to solve real-world issues and uplift communities.</p>
<br/>

<strong>Admission and Scholarships</strong>
<br/>
<p>Admissions at KU are merit-based, and the process is transparent and well-structured. It includes an entrance exam followed by interviews in many programs. The university offers scholarships to deserving and economically disadvantaged students, ensuring that education remains accessible to all.</p>

<p>There are several types of scholarships including merit-based, need-based, and partner-funded schemes. KU also encourages female participation in technical education and offers targeted scholarships to promote gender equality.</p>
<br/>

<strong>Achievements and Recognition</strong>
<br/>
<p>Kathmandu University is consistently ranked among the top universities in Nepal and has gained recognition in South Asia for its academic quality and innovation. It has produced thousands of graduates who now serve in leading roles in government, industry, academia, and civil society, both in Nepal and abroad.</p>

<p>Graduates of KU are known for their competence, discipline, and ethical values—qualities that make them sought after in the job market and respected in their professional lives.</p>
`,
  collegename: "Kathmandu University",
  established: "1991",
  collegetype: "Public",
  location: "Suburban",
  approval: null, // Universities don't typically have "approval" in the same way as medical colleges
  address: "Dhulikhel, Kavrepalanchok District, Nepal",
  state: "Kavrepalanchok District",
  city: "Dhulikhel",
  affiliatedby: null, // Universities don't typically have "affiliatedby" in the same way as medical colleges
  collegecategory: "University",
  courses: [
   {
    course: "Various Undergraduate, Graduate, and Postgraduate Programs",
    branch:
     "Science, Engineering, Management, Arts, Education, Medical Sciences, Law",
    totalSeat: null, // Research needed for specific seat data per program
    courseDuration: null, // Research needed for specific duration per program
    tuitionFee: "41,68,090/-", // Research needed for specific tuition per program
   },
  ],
  pdf: KathmanduUniversity,
  cutoffdata: [], // Research needed for cutoff data (if applicable)
  website: "http://www.ku.edu.np/", // added website from research.
  mail: null, // Research needed for official email
  image1:
   "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Kathmandu_University%2C_Nepal.jpg/2560px-Kathmandu_University%2C_Nepal.jpg", // Image URLs or base64 strings would need to be added
  image2:
   "https://upload.wikimedia.org/wikipedia/en/thumb/c/cb/Kathmandu_University_Logo.svg/220px-Kathmandu_University_Logo.svg.png", // Image URLs or base64 strings would need to be added
 },
 {
  id: "5",
  universityDescription: `<strong>Patan Academy of Health Sciences</strong><br>
Patan Academy of Health Sciences (PAHS) is a distinguished and progressive medical institution located in Lalitpur, Nepal. Established with a clear mission to improve the health care system of Nepal, particularly in rural and underserved areas, PAHS has emerged as one of the leading institutions for medical education, research, and health service delivery in the country. What makes PAHS unique is its strong commitment to social accountability, community-based learning, and the holistic development of medical professionals who are not only technically competent but also socially responsible.<br><br>

<strong>Vision and Mission</strong><br>
The vision of PAHS is to become a model academic institution that trains health professionals to meet the healthcare needs of the people of Nepal, especially the poor and marginalized. Its mission includes producing compassionate, skilled, and ethical health workers who are committed to serving in rural and remote areas. PAHS stands out among other institutions for its dedication to addressing the human resource crisis in the health sector of Nepal by producing graduates who will work in the places where they are needed the most.<br><br>

<strong>History and Background</strong><br>
The academy was established by an Act of Parliament of Nepal in 2008. The government of Nepal, recognizing the urgent need for qualified health professionals, collaborated with national and international stakeholders to create this autonomous, not-for-profit public academic institution. PAHS was built around the well-known Patan Hospital, which has a long-standing reputation for providing quality health services to the community. The hospital itself has been operating for over three decades and serves as the primary teaching hospital for the academy.<br><br>

<strong>Academic Programs</strong><br>
PAHS offers a variety of academic programs, with the Bachelor of Medicine and Bachelor of Surgery (MBBS) being the flagship course. The MBBS program is designed in a way that not only provides students with scientific and clinical knowledge but also emphasizes public health, rural exposure, ethics, communication skills, and professionalism.<br><br>
The MBBS curriculum at PAHS is community-oriented and integrated. The students are required to undergo field-based learning experiences throughout their academic journey. From the early years, students spend significant time in rural communities, where they learn directly about the realities of public health, socioeconomic issues, and healthcare delivery. This approach nurtures empathy, critical thinking, and a sense of social justice.<br><br>
In addition to the MBBS program, PAHS also offers postgraduate programs in various clinical disciplines, including MD, MS, and other residency programs. These programs aim to develop specialists who are not only clinically competent but also committed to working in the healthcare system of Nepal.<br><br>
The institution also provides nursing education and public health programs, thereby contributing to the development of a multidisciplinary health workforce.<br><br>

<strong>Admission Policy</strong><br>
One of the most notable features of PAHS is its inclusive and socially responsible admission policy. The selection process is carefully designed to promote diversity and equity. Special consideration is given to candidates from rural, remote, and disadvantaged backgrounds. PAHS ensures that a significant proportion of seats are reserved for such students, as they are more likely to return and serve in underserved communities after graduation.<br><br>
The admission process is rigorous, transparent, and merit-based. It includes written exams, interviews, and assessments of applicants’ motivation and commitment to serve in Nepal’s rural health system.<br><br>

<strong>Campus and Facilities</strong><br>
PAHS is located in the heart of Lalitpur district in the Kathmandu Valley, adjacent to the Patan Hospital. The campus provides a serene and inspiring environment for learning. The infrastructure includes lecture halls, seminar rooms, laboratories, libraries, and student hostels. The Patan Hospital, with more than 400 beds, acts as the teaching hospital, offering students hands-on clinical experience across multiple specialties.<br><br>
The hospital has departments such as Internal Medicine, Surgery, Pediatrics, Obstetrics and Gynecology, Orthopedics, Psychiatry, and more. It also offers diagnostic services, emergency care, and specialized clinics. This real-world clinical exposure is critical to the training of students and is aligned with the philosophy of learning through service.<br><br>

<strong>Faculty and Teaching Approach</strong><br>
PAHS boasts a team of highly qualified and experienced faculty members. The faculty is dedicated not just to academic excellence, but also to mentorship, personal development, and ethical practice. Many of them have received international training and bring global perspectives to local challenges.<br><br>
The teaching methodology at PAHS is interactive and student-centered. It includes Problem-Based Learning (PBL), small group discussions, fieldwork, clinical rotations, simulations, and community health projects. This approach encourages critical thinking, teamwork, self-directed learning, and ethical reasoning.<br><br>

<strong>Research and Innovation</strong><br>
Research is a key component of the academic mission at PAHS. Students and faculty are encouraged to engage in research activities that address real-world problems in Nepal’s healthcare system. PAHS focuses on operational research, community-based research, and public health studies. The institution has collaborations with several international universities and organizations, allowing students and faculty to participate in global research projects.<br><br>
By integrating research with medical education, PAHS ensures that future doctors not only follow existing knowledge but also contribute to the advancement of medical science and public health policies in Nepal.<br><br>

<strong>Community Outreach and Social Impact</strong><br>
PAHS has a strong connection with the community. It conducts community-based education, health camps, health awareness programs, and mobile clinics. These initiatives bring healthcare services to remote and marginalized populations while providing invaluable learning experiences to students.<br><br>
One of the core components of the MBBS program is the Community Based Learning and Education (CBLE). Through this, students are placed in rural communities for extended periods, where they live and work among the people. This helps them understand the cultural, economic, and environmental determinants of health, and inspires a sense of responsibility and compassion.<br><br>
Graduates of PAHS have consistently demonstrated a commitment to serve in government hospitals, rural health posts, and non-profit organizations, thereby addressing the urban-rural health divide in Nepal.<br><br>

<strong>International Recognition and Collaborations</strong><br>
PAHS has gained recognition not only nationally but also internationally. Its innovative educational model has been praised by global institutions for its social accountability and rural focus. The academy maintains collaborations with reputed universities and organizations across the globe, including partnerships in the USA, UK, Australia, Norway, and Japan.<br><br>
These collaborations bring new opportunities for exchange programs, faculty development, research funding, and global exposure for students.<br><br>

<strong>Ethical and Cultural Values</strong><br>
At the heart of PAHS is a strong foundation of ethical and cultural values. Students are taught to be compassionate caregivers who respect patient dignity, confidentiality, and cultural sensitivities. The curriculum includes courses on medical ethics, humanities, and professionalism, ensuring that graduates are not only skilled clinicians but also empathetic human beings.
`,
  collegename: "Patan Academy of Health Sciences",
  established: "2008",
  collegetype: "Public",
  location: "Nepal ",
  approval: "Act of Parliament of Nepal",
  address: "Lalitpur, Nepal (adjacent to Patan Hospital)",
  state: "Lalitpur",
  city: "Lalitpur",
  affiliatedby: null, // As it's an autonomous public institution, it doesn't have a typical "affiliatedby"
  collegecategory: "Medical",
  pdf: Patanacademyofhealth,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine and Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: "69,72,000/-", // Research needed for specific tuition data
   },
   {
    course: "MD/MS",
    branch: "Various clinical disciplines",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Nursing Education",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Public Health Programs",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: "http://pahs.edu.np/", // added website from research.
  mail: null, // Research needed for official email
  image1:
   "https://edusquareconsulting.com/wp-content/uploads/2024/08/Patan-Academy-of-Health-Sciences.png", // Image URLs or base64 strings would need to be added
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUwyXdFDLPVQtuG878WTM-woOb3-cNkXEH9Q&s", // Image URLs or base64 strings would need to be added
 },
 {
  id: "6",
  universityDescription: `<strong>Nobel Medical College: A Comprehensive Overview</strong><br><br>

Nobel Medical College, located in Biratnagar, Nepal, is one of the leading private medical institutions in the country, known for its academic excellence, modern infrastructure, and commitment to healthcare education. Established with the mission of producing competent healthcare professionals who can meet the ever-growing demands of the healthcare sector in Nepal and abroad, the college has grown significantly in reputation and size over the years.<br><br>

<strong>Location and Setting</strong><br>
Nobel Medical College is situated in Biratnagar, the industrial and educational hub of eastern Nepal. The city’s favorable climate, access to modern amenities, and cultural diversity make it a comfortable and stimulating environment for students from across Nepal and international students, particularly from India and neighboring countries. The college is spread over a large campus that combines natural beauty with modern facilities, providing a peaceful and focused learning atmosphere.<br><br>

<strong>Establishment and Mission</strong><br>
The college was established with a vision to provide high-quality medical education and contribute meaningfully to the healthcare system in Nepal. Its mission is not just to produce doctors and nurses but to mold individuals into compassionate healthcare providers who value ethics, empathy, and social responsibility. Nobel Medical College believes in a holistic education model that includes both theoretical knowledge and practical experience.<br><br>

<strong>Academic Programs</strong><br>
Nobel Medical College offers a wide range of programs in the field of health sciences. The core academic offerings include:
<ul>
  <li><strong>MBBS (Bachelor of Medicine and Bachelor of Surgery)</strong> – This is the flagship undergraduate program of the institution, aimed at producing competent, skilled, and ethical medical practitioners.</li>
  <li><strong>BDS (Bachelor of Dental Surgery)</strong> – For students interested in oral and dental health, the BDS program provides a comprehensive curriculum supported by state-of-the-art labs and clinical exposure.</li>
  <li><strong>Nursing Programs (B.Sc. Nursing, PCL Nursing)</strong> – The nursing department offers both professional and diploma courses to train nursing staff for hospitals and community health services.</li>
  <li><strong>Postgraduate Medical Programs (MD/MS)</strong> – The college has started offering postgraduate courses in various specialties, helping to develop advanced skills in medical disciplines.</li>
</ul>
The academic curriculum is approved by the Nepal Medical Council (NMC) and affiliated with Kathmandu University, ensuring high standards in line with international benchmarks.<br><br>

<strong>Faculty and Teaching Methods</strong><br>
The faculty at Nobel Medical College includes experienced professors, doctors, and academicians who are highly qualified and dedicated to teaching. Many of them have international exposure and regularly attend conferences and training to stay updated with global medical advancements.<br>
Teaching methodologies are a mix of traditional classroom lectures, problem-based learning (PBL), case discussions, simulation-based teaching, and clinical rotations. Students are exposed to patients from the early years of their studies, which enhances their confidence and clinical acumen. The integration of technology in classrooms, such as smart boards and multimedia presentations, helps make learning interactive and engaging.<br><br>

<strong>Affiliated Hospital: Nobel Teaching Hospital</strong><br>
One of the strongest pillars of Nobel Medical College is the Nobel Teaching Hospital, which serves as the clinical training ground for students. The hospital is a multi-specialty facility with over 700 beds and caters to thousands of patients annually. It has departments in general medicine, surgery, pediatrics, gynecology, orthopedics, cardiology, ENT, ophthalmology, dermatology, psychiatry, and more.<br>
The hospital not only helps students get real-time clinical exposure but also plays a vital role in providing quality healthcare services to the local and regional population at affordable costs. Community outreach programs and health camps are regularly organized to promote public health awareness and service.<br><br>

<strong>Infrastructure and Facilities</strong><br>
Nobel Medical College has invested heavily in building a world-class infrastructure. Key features of the campus include:
<ul>
  <li><strong>Modern Classrooms and Lecture Halls</strong> – Spacious, well-ventilated rooms equipped with audio-visual teaching aids.</li>
  <li><strong>Well-stocked Library</strong> – A comprehensive collection of textbooks, reference materials, national and international journals, digital resources, and e-library access.</li>
  <li><strong>Laboratories</strong> – Advanced and fully equipped labs for anatomy, physiology, biochemistry, microbiology, pharmacology, pathology, and forensic medicine.</li>
  <li><strong>Dissection Hall</strong> – A large and hygienic dissection room that supports hands-on anatomical learning for MBBS students.</li>
  <li><strong>Computer and IT Center</strong> – High-speed internet and computer labs facilitate digital learning and research.</li>
  <li><strong>Hostel Facilities</strong> – Separate hostels for boys and girls with 24/7 security, Wi-Fi, clean mess, and recreational areas.</li>
  <li><strong>Cafeteria and Dining</strong> – Hygienic and nutritious food options catering to diverse tastes.</li>
  <li><strong>Sports and Recreation</strong> – Facilities for indoor and outdoor games, gym, yoga sessions, and cultural activities to ensure overall development.</li>
</ul><br>

<strong>Student Life and Culture</strong><br>
Life at Nobel Medical College is vibrant and dynamic. Students from different regions of Nepal and countries like India, Bhutan, and Bangladesh create a multicultural environment on campus. The college promotes a student-friendly culture with numerous extracurricular activities, clubs, student associations, and cultural festivals.<br>
Events like Fresher’s Welcome, Medical Exhibitions, Health Awareness Days, and Annual Sports Week foster camaraderie, leadership, and social engagement among students. Regular seminars, workshops, and guest lectures by eminent healthcare professionals provide additional learning beyond the syllabus.<br>
The college also encourages students to participate in research activities and publications. Several students have presented papers at national and international conferences, highlighting the institution's focus on academic excellence and innovation.<br><br>

<strong>International Students and Recognition</strong><br>
Nobel Medical College has gained recognition among international students, especially from India, due to its proximity, similar curriculum, English-medium instruction, and affordable tuition fees compared to private colleges in India. It is recognized by the Medical Council of India (MCI), now known as National Medical Commission (NMC), making it a viable option for Indian students preparing for the FMGE or NEXT exams.<br>
The college is also listed in the World Directory of Medical Schools, making its graduates eligible to appear for licensing exams like USMLE, PLAB, and AMC in the United States, United Kingdom, and Australia respectively.<br><br>

<strong>Admission Process</strong><br>
Admission to Nobel Medical College is based on entrance examinations, academic performance, and eligibility criteria set by Kathmandu University and the Nepal Medical Council. For international students, the college provides guidance and support with documentation, visa processes, and settling into campus life.<br><br>

<strong>Vision for the Future</strong><br>
With the changing landscape of medical education and global health challenges, Nobel Medical College aims to stay ahead by introducing new courses, expanding postgraduate specialties, embracing digital health technologies, and strengthening research collaborations. The management envisions turning Nobel into a center of excellence not only in academics but also in medical innovations and community service.
`,
  collegename: "Nobel Medical College",
  established: null, // Research needed for specific establishment year
  collegetype: "Private",
  location: "Nepal ",
  approval: "Nepal Medical Council (NMC)",
  address: "Biratnagar, Nepal",
  state: "Koshi Province", //added state from research
  city: "Biratnagar",
  affiliatedby: "Kathmandu University",
  collegecategory: "Medical",
  pdf: NobelMedicalclg,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine and Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: "47,50,000/-", // Research needed for specific tuition data
   },
   {
    course: "BDS",
    branch: "Bachelor of Dental Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "B.Sc. Nursing",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "PCL Nursing",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "MD/MS",
    branch: "Various specialties",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: "http://www.nmcbiratnagar.edu.np/", // added website from research.
  mail: null, // Research needed for official email
  image1:
   "https://www.collegenp.com/uploads/2024/11/nobel-medical-college-teaching-hospital-building.jpg", // Image URLs or base64 strings would need to be added
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcfmb9wwTjX4gFxiu5p_Pf9inF9lWtZq15Wg&s", // Image URLs or base64 strings would need to be added
 },
 {
  id: "7",
  universityDescription: `<strong>National Medical College – A Beacon of Excellence in Medical Education</strong><br>
Nestled in the heart of an evolving urban landscape, National Medical College (NMC) stands as a prestigious institution known for its commitment to excellence in medical education, research, and healthcare services. Since its inception, the college has nurtured a vision to cultivate the next generation of medical professionals who are not only skilled in their craft but also compassionate in their service. With world-class infrastructure, a talented faculty, and a rigorous academic curriculum, NMC has established itself as a leading center for medical studies.<br><br>

<strong>A Legacy of Trust and Excellence</strong><br>
Founded with the purpose of addressing the growing need for quality healthcare professionals, National Medical College has grown from a humble beginning to a renowned institution admired across the country. The college prides itself on its student-first philosophy, which blends academic rigor with a deep sense of moral and ethical responsibility. Over the years, it has produced thousands of doctors, specialists, and researchers who have gone on to serve humanity in various capacities.<br><br>

<strong>Campus and Infrastructure</strong><br>
The sprawling campus of NMC is a harmonious blend of modern architecture and green, open spaces. Spread across several acres, the campus houses state-of-the-art academic blocks, a well-equipped hospital, hostels, research centers, laboratories, a central library, and recreational areas.<br>
<ul>
  <li><strong>Academic Blocks:</strong> Spacious, air-conditioned halls with advanced audio-visual aids, smart classrooms, e-learning modules, and simulation labs.</li>
  <li><strong>Library:</strong> Over 50,000 books, 200+ journals, online databases, and research publications.</li>
  <li><strong>Laboratories:</strong> Modern labs for Anatomy, Physiology, Biochemistry, Pathology, Microbiology, Pharmacology, and Forensic Medicine.</li>
  <li><strong>Hospital Facility:</strong> A multi-specialty teaching hospital with more than 1000 beds for clinical training and real-world exposure.</li>
  <li><strong>Hostels and Residences:</strong> Clean, safe, and comfortable separate accommodations for boys and girls with staff quarters and guest houses.</li>
</ul><br>

<strong>Academics and Programs Offered</strong><br>
National Medical College offers a comprehensive MBBS program along with several postgraduate and diploma courses.<br>
<ul>
  <li><strong>MBBS Program:</strong> 5.5-year program including internship, emphasizing strong basics and clinical exposure.</li>
  <li><strong>Postgraduate Courses:</strong> MD/MS in General Medicine, Surgery, Pediatrics, Orthopedics, and more.</li>
  <li><strong>Allied Health Sciences and Nursing:</strong> Programs in Nursing, Physiotherapy, Lab Technology, and other health services.</li>
  <li><strong>Research and Development:</strong> Active support for student and faculty research, publications, and conferences.</li>
</ul><br>

<strong>Experienced and Dedicated Faculty</strong><br>
The faculty includes experienced professors and researchers passionate about teaching and mentoring. Many have published widely and are involved in innovative research activities.<br><br>

<strong>Student Life and Extracurricular Activities</strong><br>
Life at NMC is vibrant, focusing on academic excellence and holistic growth.<br>
<ul>
  <li><strong>Student Unions and Societies:</strong> Platforms for leadership, cultural interaction, and community service.</li>
  <li><strong>Annual Fest:</strong> National-level cultural and sports events.</li>
  <li><strong>Medical Camps and Outreach:</strong> Free health camps, awareness drives, and rural outreach programs.</li>
</ul><br>

<strong>Clinical Exposure and Hospital Training</strong><br>
From the third year onward, students participate in ward rounds, OPDs, and surgeries. The hospital covers all major and super-specialties with high patient inflow, ensuring comprehensive clinical experience.<br><br>

<strong>Global Connections and Collaborations</strong><br>
NMC offers international exposure through partnerships, exchange programs, global internships, and guest lectures from international experts.<br><br>

<strong>Commitment to Ethics and Empathy</strong><br>
Ethics, empathy, and values are deeply embedded in the curriculum, fostering respect and compassion in medical practice.<br><br>

<strong>Alumni Network and Placement</strong><br>
NMC boasts a strong alumni network of successful professionals worldwide. A dedicated Career Guidance and Placement Cell supports students in exam preparation (USMLE/PLAB/NEET PG) and placements.<br><br>

<strong>Admission and Selection Process</strong><br>
Admission is based on NEET and follows transparent, merit-based selection criteria, with government-regulated reservation policies to ensure inclusivity.<br>
`,
  collegename: "National Medical College",
  established: null, // Research needed for specific establishment year
  collegetype: "Private", //Assuming Private due to description, but needs verification
  location: "Nepal ",
  approval: "National Medical Commission (NMC)",
  address: "Nepal  Location, India (Specific location needed)",
  state: null, // Specific state needed
  city: null, // Specific city needed
  affiliatedby: null, //Research required to find affiliation
  collegecategory: "Medical",
  pdf: NationalMedicalclg,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "5.5 years (including a 1-year internship)",
    tuitionFee: "50,00,000/-", // Research needed for specific tuition data
   },
   {
    course: "MD/MS",
    branch:
     "General Medicine, Pediatrics, Surgery, Orthopedics, Obstetrics and Gynecology, Dermatology, Psychiatry, Anesthesiology, Radiology, and more.",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Nursing",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Physiotherapy",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Lab Technology",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Allied Health Sciences",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: null, // Research needed for official website
  mail: null, // Research needed for official email
  image1:
   "https://edusquareconsulting.com/wp-content/uploads/2024/08/National-Medical-College-Birgunj.jpg", // Image URLs or base64 strings would need to be added
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTa5FYR-_aBoZUfu8TmfeI8XaGd7xYtIsebgw&s", // Image URLs or base64 strings would need to be added
 },
 {
  id: "8",
  universityDescription: `<strong>Lumbini Medical College – A Comprehensive Overview</strong><br>
Lumbini Medical College (LMC) is one of the prominent institutions for medical education in Nepal. Situated in the peaceful and historically rich region of Palpa, Tansen, the college serves as a beacon of medical excellence, offering undergraduate and postgraduate programs in medicine, nursing, and allied health sciences. Over the years, LMC has garnered a reputation for academic rigor, clinical excellence, and a strong commitment to community healthcare.<br><br>

<strong>Location and Campus</strong><br>
Nestled amidst the picturesque hills of the Palpa district, Lumbini Medical College enjoys a serene environment conducive to learning and personal development. The college is located in Tansen, known for its cultural heritage and Himalayan views.<br>
<ul>
  <li>Located in a peaceful town with a pleasant climate</li>
  <li>Campus includes academic buildings, a teaching hospital, hostels, faculty quarters, and recreational areas</li>
  <li>Infrastructure supports high standards of education and patient care</li>
</ul><br>

<strong>History and Establishment</strong><br>
Lumbini Medical College was established in 2005 to provide quality medical education and healthcare in western Nepal.<br>
<ul>
  <li>Founded by visionary doctors and entrepreneurs</li>
  <li>Aimed at addressing rural healthcare needs and education</li>
  <li>Expanded academic offerings and hospital facilities over the years</li>
</ul><br>

<strong>Academic Programs</strong><br>
LMC offers a variety of academic programs tailored for medical professionals.<br>
<ul>
  <li><strong>MBBS Program:</strong> Recognized by Nepal Medical Council, follows international standards</li>
  <li><strong>Nursing Programs:</strong> B.Sc Nursing and BNS programs</li>
  <li><strong>Postgraduate Courses:</strong> MD/MS in specialties like Internal Medicine, Pediatrics, Surgery, etc.</li>
  <li>Curriculum emphasizes evidence-based medicine and community health</li>
  <li>Encourages research and outreach from early stages</li>
</ul><br>

<strong>Teaching Hospital</strong><br>
LMC’s teaching hospital is a vital part of the college’s practical education and healthcare services.<br>
<ul>
  <li>Multi-specialty hospital with over 600 beds</li>
  <li>Departments include Internal Medicine, Surgery, Pediatrics, Orthopedics, ENT, Dermatology, and more</li>
  <li>Facilities like ICU, NICU, Radiology, and Operation Theatres</li>
  <li>Thousands of outpatient and inpatient cases annually</li>
  <li>Community services like health camps and mobile clinics</li>
</ul><br>

<strong>Faculty and Teaching Standards</strong><br>
The college prides itself on its experienced and dedicated faculty.<br>
<ul>
  <li>Professors and lecturers with national and international experience</li>
  <li>Uses lectures, group discussions, case studies, and clinical rotations</li>
  <li>Incorporates modern tools like AV aids, e-learning, and simulations</li>
  <li>Focuses on student-centered and problem-based learning</li>
</ul><br>

<strong>Student Life and Facilities</strong><br>
LMC provides a well-rounded environment for academic and personal growth.<br>
<ul>
  <li>Diverse student population from Nepal and neighboring countries</li>
  <li>Separate, safe, and well-equipped hostels for males and females</li>
  <li>Cafeteria, sports areas, internet, and recreational facilities</li>
  <li>Encourages participation in clubs, cultural events, sports, and seminars</li>
</ul><br>

<strong>Recognition and Affiliations</strong><br>
Lumbini Medical College is widely recognized and affiliated with reputable academic bodies.<br>
<ul>
  <li>Affiliated with Kathmandu University</li>
  <li>Recognized by Nepal Medical Council (NMC)</li>
  <li>Graduates eligible for USMLE, FMGE, and other global licensing exams</li>
</ul><br>

<strong>Research and Innovation</strong><br>
LMC fosters a strong research culture among students and faculty.<br>
<ul>
  <li>Encourages clinical and community-based research projects</li>
  <li>Conducts workshops, training, and journal clubs</li>
  <li>Many publications in national and international journals</li>
  <li>Students engage in small research initiatives early on</li>
</ul><br>

<strong>Community Outreach and Social Responsibility</strong><br>
Community service is central to LMC’s mission.<br>
<ul>
  <li>Regular free health camps and awareness programs</li>
  <li>Outreach initiatives in nearby villages and rural areas</li>
  <li>Students gain real-world public health exposure</li>
  <li>Promotes empathy, communication, and social responsibility</li>
</ul><br>
`,
  collegename: "Lumbini Medical College",
  established: "2005",
  collegetype: "Private", // Assuming private, but needs verification
  location: "Suburban",
  approval: "Nepal Medical Council (NMC)",
  address: "Tansen, Palpa, Nepal",
  state: "Palpa",
  city: "Tansen",
  affiliatedby: "Kathmandu University",
  collegecategory: "Medical",
  pdf: LumbiniMedicalclg,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: "55,94,000/-", // Research needed for specific tuition data
   },
   {
    course: "B.Sc. Nursing",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "BNS",
    branch: "Bachelor in Nursing Science",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "MD/MS",
    branch:
     "Internal Medicine, General Surgery, Pediatrics, Obstetrics and Gynecology, and more.",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: "http://www.lmc.edu.np/", // added website from research.
  mail: null, // Research needed for official email
  image1: "https://lmc.edu.np/media/home-page-content/sa.webp", // Image URLs or base64 strings would need to be added
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSOM_u_RxqEkwKk3mjyCZiRzplJRH3qEUUWlQ&s", // Image URLs or base64 strings would need to be added
 },
 {
  id: "9",
  universityDescription: `<strong>Kathmandu Medical College (KMC) – A Comprehensive Overview</strong><br><br>

<strong>Introduction</strong><br>
Kathmandu Medical College (KMC), located in the vibrant city of Kathmandu, Nepal, is one of the most respected and sought-after institutions for medical education in the country. Established in 1997, KMC has steadily evolved into a center of excellence in the fields of medical education, clinical training, and research. With its affiliation to Kathmandu University and recognition by various national and international bodies, KMC has become a preferred destination for aspiring medical professionals from Nepal, India, and other neighboring countries.<br><br>

<strong>Academic Excellence and Programs</strong><br>
<ul>
  <li>KMC offers the MBBS program spanning five and a half years, including a one-year internship.</li>
  <li>Postgraduate courses available in Internal Medicine, Surgery, Pediatrics, Orthopedics, Obstetrics and Gynecology, Anesthesiology, Radiology, and more.</li>
  <li>Nursing and allied health science programs are also provided.</li>
  <li>The teaching approach includes PBL, interactive sessions, internal assessments, clinical postings, and seminars.</li>
</ul><br>

<strong>Faculty and Teaching Standards</strong><br>
<ul>
  <li>Highly qualified faculty with national and international experience.</li>
  <li>Faculty development through regular workshops and collaborations.</li>
  <li>Student-teacher interaction and mentoring are strongly encouraged.</li>
</ul><br>

<strong>Infrastructure and Campus Facilities</strong><br>
<ul>
  <li>Two campuses: Basic Sciences Campus (Duwakot) and Clinical Sciences Campus (Sinamangal).</li>
  <li>Facilities include lecture halls, labs, library, computer labs, dissection halls, and recreational areas.</li>
  <li>Kathmandu Medical College Teaching Hospital (KMCTH) with 900 beds and full clinical services.</li>
  <li>Hostel accommodations with mess, internet, security, and recreation areas.</li>
</ul><br>

<strong>International Recognition and Career Opportunities</strong><br>
<ul>
  <li>Recognized by Nepal Medical Council, Sri Lanka Medical Council, and listed in WDOMS.</li>
  <li>Graduates are eligible for USMLE, PLAB, AMC, and FMGE exams.</li>
  <li>Career counseling cell supports clinical practice, higher education, research, and public health careers.</li>
</ul><br>

<strong>Research and Innovation</strong><br>
<ul>
  <li>Focus on clinical, epidemiological, and public health research.</li>
  <li>Students participate in research projects, conferences, and journal publications.</li>
  <li>Collaborations with Kathmandu University and health organizations.</li>
</ul><br>

<strong>Community Engagement and Social Responsibility</strong><br>
<ul>
  <li>Involvement in rural postings, health camps, awareness programs, and vaccination drives.</li>
  <li>Community Medicine Department integrates public health teaching with fieldwork.</li>
  <li>Focus on preventive medicine and understanding underserved populations.</li>
</ul><br>

<strong>Student Life and Extracurriculars</strong><br>
<ul>
  <li>Balanced academic and personal development through events and competitions.</li>
  <li>Student Welfare Council organizes activities and represents students.</li>
  <li>Counseling services and stress management are available.</li>
  <li>Festivals celebrated with enthusiasm, creating a family-like atmosphere.</li>
</ul><br>

<strong>Admissions and Eligibility</strong><br>
<ul>
  <li>MBBS admission based on MEC entrance exam for Nepali students.</li>
  <li>NEET qualification required for Indian students.</li>
  <li>Merit-based selection with a structured fee system.</li>
  <li>Scholarships available for deserving and underprivileged students.</li>
</ul>
`,
  collegename: "Kathmandu Medical College",
  established: "1997",
  collegetype: "Private", // Assuming private, but needs verification
  location: "Nepal ",
  approval: "Nepal Medical Council (NMC)",
  address:
   "Duwakot (Basic Sciences Campus) & Sinamangal, Kathmandu (Clinical Sciences Campus)",
  state: "Kathmandu",
  city: "Kathmandu",
  affiliatedby: "Kathmandu University",
  collegecategory: "Medical",
  pdf: KathmanduMedicalclg,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "5.5 years (including a 1-year internship)",
    tuitionFee: "50,00,000/-", // Research needed for specific tuition data
   },
   {
    course: "MD/MS",
    branch:
     "Internal Medicine, General Surgery, Pediatrics, Orthopedics, Obstetrics and Gynecology, Anesthesiology, Radiology, and more.",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Nursing Programs",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Allied Health Science Programs",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: "http://www.kmc.edu.np/", // added website from research.
  mail: null, // Research needed for official email
  image1:
   "https://ik.imagekit.io/syustaging/SYU_PREPROD/Kathmandu-Medical-College_vefQHhnDfZ.webp?tr=w-3840", // Image URLs or base64 strings would need to be added
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzO5L2VEHZrxKl_Vis461v7cJ_zB4PsTTO6Q&s", // Image URLs or base64 strings would need to be added
 },
 {
  id: "10",
  universityDescription: `<strong>KIST Medical College and Teaching Hospital – A Comprehensive Overview</strong><br><br>

<strong>Establishment and Vision</strong><br>
<ul>
  <li>Established in 2006 by medical professionals and education entrepreneurs.</li>
  <li>Affiliated with Tribhuvan University.</li>
  <li>Mission to produce competent, compassionate, and community-oriented doctors.</li>
  <li>Promotes ethical medical practices and lifelong learning.</li>
</ul><br>

<strong>Campus and Infrastructure</strong><br>
<ul>
  <li>Located in Imadol, Lalitpur, close to Kathmandu.</li>
  <li>Modern infrastructure with lecture halls, seminar rooms, and labs.</li>
  <li>Includes anatomy dissection hall and digital library with online resources.</li>
  <li>Hostels with 24/7 security, hygienic dining, and recreational facilities.</li>
  <li>Canteen provides local and international meals, catering to foreign students.</li>
</ul><br>

<strong>Teaching Hospital</strong><br>
<ul>
  <li>Attached KIST Teaching Hospital (KISTTH) with over 300 beds.</li>
  <li>Facilities include ICU, NICU, PICU, and modular operating theatres.</li>
  <li>Offers outpatient and inpatient services in multiple specialties.</li>
  <li>Staffed with experienced consultants and specialists who also teach.</li>
</ul><br>

<strong>Academic Programs</strong><br>
<ul>
  <li>MBBS program of five and a half years including a one-year internship.</li>
  <li>Curriculum aligned with Nepal Medical Council and Tribhuvan University.</li>
  <li>Pre-clinical subjects in first two years; clinical rotations from third year.</li>
  <li>Teaching methods include lectures, group discussions, seminars, and skills lab training.</li>
  <li>Plans to introduce postgraduate and allied health programs.</li>
</ul><br>

<strong>Faculty and Academic Environment</strong><br>
<ul>
  <li>Qualified faculty with national and international experience.</li>
  <li>Optimal student-to-teacher ratio for personalized guidance.</li>
  <li>Faculty development programs to update teaching techniques.</li>
  <li>Research encouraged; students present in national and international conferences.</li>
</ul><br>

<strong>Student Life and Support Services</strong><br>
<ul>
  <li>Inclusive student culture with sports, cultural events, and debates.</li>
  <li>Participation in health camps, awareness programs, and student exchanges.</li>
  <li>Student Support Unit for counseling, career guidance, and grievance redressal.</li>
  <li>Special support for international students including visa and accommodation help.</li>
</ul><br>

<strong>Community Outreach and Social Responsibility</strong><br>
<ul>
  <li>Regular health camps, mobile clinics, and vaccination drives in rural areas.</li>
  <li>Community Medicine Department coordinates field visits and public health research.</li>
  <li>Focus on understanding health in socio-economic contexts.</li>
</ul><br>

<strong>Accreditation and Recognition</strong><br>
<ul>
  <li>Recognized by Nepal Medical Council.</li>
  <li>Affiliated with Tribhuvan University.</li>
  <li>Listed in international medical directories.</li>
  <li>Graduates eligible for global licensing exams like USMLE, PLAB, AMC, FMGE.</li>
</ul>
`,
  collegename: "KIST Medical College and Teaching Hospital",
  established: "2006",
  collegetype: "Private",
  location: "Suburban",
  approval: "Nepal Medical Council (NMC)",
  address: "Imadol, Lalitpur, Nepal",
  state: "Lalitpur",
  city: "Lalitpur",
  affiliatedby: "Tribhuvan University",
  collegecategory: "Medical",
  pdf: Kistmedicalclg,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "5.5 years (including a 1-year internship)",
    tuitionFee: "55,50,000/-", // Research needed for specific tuition data
   },
   // Adding room for future courses based on description
   {
    course: "Postgraduate Courses",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Allied Health Programs",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: "http://kistmcth.edu.np/", // added website from research.
  mail: null, // Research needed for official email
  image1: "https://www.kistmcth.edu.np/uploads/album/1686456131.jpg", // Image URLs or base64 strings would need to be added
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQrBO59O394d8eFHJoP1wxijI9s0TKDrdj1FQ&s", // Image URLs or base64 strings would need to be added
 },
 {
  id: "11",
  universityDescription: `<strong>Janaki Medical College – A Comprehensive Overview</strong><br><br>

<strong>Introduction</strong><br>
<ul>
  <li>Located in Janakpur, Madhesh Province – a city rich in history and culture.</li>
  <li>Named after Goddess Sita (Janaki), promoting ethical, compassionate, and skilled medical professionals.</li>
  <li>Plays a key role in uplifting regional healthcare and medical education standards.</li>
</ul><br>

<strong>Establishment and Vision</strong><br>
<ul>
  <li>Established by visionary professionals and academicians.</li>
  <li>Aims to deliver quality medical education and healthcare services.</li>
  <li>Focused on academic excellence, practical experience, and ethical medical practice.</li>
</ul><br>

<strong>Location and Accessibility</strong><br>
<ul>
  <li>Located in Janakpur, Dhanusha District, near the Indian border.</li>
  <li>Strategic, accessible location for both Nepali and Indian students.</li>
  <li>Provides an inspiring academic and cultural setting for medical studies.</li>
</ul><br>

<strong>Affiliation and Recognition</strong><br>
<ul>
  <li>Affiliated with Tribhuvan University (TU), Nepal’s oldest university.</li>
  <li>Recognized by the Nepal Medical Council (NMC).</li>
  <li>MBBS degree acknowledged nationally and internationally.</li>
</ul><br>

<strong>Academic Programs</strong><br>
<ul>
  <li>Offers a five-and-a-half-year MBBS program including a one-year internship.</li>
  <li>Subjects include basic sciences and clinical disciplines such as Medicine, Surgery, Pediatrics, etc.</li>
  <li>Also expanding into postgraduate and paramedical programs.</li>
</ul><br>

<strong>Faculty and Teaching Staff</strong><br>
<ul>
  <li>Highly experienced faculty with international academic exposure.</li>
  <li>Focus on interactive, student-centered learning approaches.</li>
  <li>Seminars, workshops, and clinical case discussions are conducted regularly.</li>
</ul><br>

<strong>Infrastructure and Facilities</strong><br>
<ul>
  <li>Spacious, air-conditioned classrooms with AV aids.</li>
  <li>Advanced laboratories for all medical science disciplines.</li>
  <li>Cadaver dissection hall for anatomy practice.</li>
  <li>Library with physical and digital resources including international journals.</li>
  <li>Computer lab with internet access for academic research.</li>
</ul><br>

<strong>Janaki Medical College Teaching Hospital (JMCTH)</strong><br>
<ul>
  <li>Over 300-bed hospital serving as the student clinical training center.</li>
  <li>Departments include Medicine, Surgery, Pediatrics, ENT, Psychiatry, etc.</li>
  <li>Facilities include:</li>
  <ul>
    <li>Modern operation theatres</li>
    <li>24/7 emergency services</li>
    <li>ICU, NICU, and PICU units</li>
    <li>Radiology and imaging (X-ray, CT, Ultrasound)</li>
    <li>Pharmacy and pathology services</li>
    <li>Ambulance facilities</li>
  </ul>
</ul><br>

<strong>Student Life</strong><br>
<ul>
  <li>Diverse and inclusive environment with students from Nepal and abroad.</li>
  <li>Safe hostels with separate facilities for boys and girls, plus Wi-Fi and mess.</li>
  <li>Cafeteria serving hygienic, nutritious meals.</li>
  <li>Engagement in sports, cultural events, debates, quizzes, and awareness campaigns.</li>
  <li>Support through counseling, mentoring, and academic guidance services.</li>
</ul><br>

<strong>Community Outreach and Public Health</strong><br>
<ul>
  <li>Regular health camps, immunization drives, and awareness programs.</li>
  <li>Hands-on rural exposure for students in real-world healthcare delivery.</li>
</ul><br>

<strong>Research and Development</strong><br>
<ul>
  <li>Emphasis on research-driven education and evidence-based medicine.</li>
  <li>Students are encouraged to take up small research projects.</li>
  <li>Faculty actively publish clinical research and contribute to medical science in Nepal.</li>
</ul><br>

<strong>International Opportunities</strong><br>
<ul>
  <li>Graduates pursue further studies and licensing exams like USMLE, PLAB, FMGE, AMC.</li>
  <li>College provides support and counseling for global exam preparation.</li>
  <li>Alumni practicing medicine in countries such as the USA, UK, India, and Australia.</li>
</ul>
`,
  collegename: "Janaki Medical College",
  established: null, // Research needed for specific establishment year
  collegetype: "Private", // Assuming private, but needs verification
  location: "Nepal ",
  approval: "Nepal Medical Council (NMC)",
  address: "Janakpur, Dhanusha District, Madhesh Province, Nepal",
  state: "Madhesh Province",
  city: "Janakpur",
  affiliatedby: "Tribhuvan University (TU)",
  collegecategory: "Medical",
  pdf: JanakiMedicalclg,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "5.5 years (including a 1-year internship)",
    tuitionFee: "48,97,625/-", // Research needed for specific tuition data
   },
   {
    course: "Postgraduate Programs",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Paramedical Courses",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: null, // Research needed for official website
  mail: null, // Research needed for official email
  image1:
   "https://i0.wp.com/www.nepallivetoday.com/wp-content/uploads/2022/06/janaki-medicalcollege.jpg?fit=1900%2C800&ssl=1", // Image URLs or base64 strings would need to be added
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTtMVHHzev3f6Cgx28qnFrgybdExpr02AaIhw&s", // Image URLs or base64 strings would need to be added
 },
 {
  id: "12",
  universityDescription: `<strong>Gandaki Medical College Teaching Hospital and Research Center (GMC), Pokhara – A Comprehensive Overview</strong><br><br>

<strong>Introduction</strong><br>
Gandaki Medical College Teaching Hospital and Research Center (GMC), located in the serene and scenic city of Pokhara, Nepal, is one of the premier institutions for medical education and healthcare services in the country. Established with the vision of imparting high-quality medical education and providing world-class health services, GMC has grown into a reputable name both nationally and internationally. It is affiliated with Tribhuvan University, Kathmandu, and recognized by Nepal Medical Council (NMC), making it a desirable destination for aspiring medical students from Nepal, India, and other neighboring countries.<br><br>

<strong>Vision and Mission</strong><br>
Gandaki Medical College was founded with a mission to create competent, compassionate, and ethically responsible healthcare professionals who can serve the ever-growing needs of the society. Its vision is to contribute to the overall healthcare development of Nepal by producing world-class doctors and health workers. The college also emphasizes research and continuous learning.<br><br>

<strong>Campus and Infrastructure</strong><br>
The GMC campus is spread across several acres in Pokhara. The infrastructure includes:<br>
<ul>
  <li>Lecture halls with audio-visual aids</li>
  <li>Seminar and tutorial rooms</li>
  <li>Departmental offices</li>
  <li>Well-maintained laboratories</li>
  <li>Library with medical textbooks, journals, and digital resources</li>
</ul><br>

<strong>Teaching Hospital</strong><br>
The Gandaki Medical College Teaching Hospital is a 750+ bedded, multi-specialty hospital offering:<br>
<ul>
  <li>General Medicine</li>
  <li>Surgery</li>
  <li>Gynecology</li>
  <li>Pediatrics</li>
  <li>Orthopedics</li>
  <li>Dermatology</li>
  <li>Psychiatry</li>
  <li>Ophthalmology</li>
  <li>ENT</li>
  <li>Dentistry</li>
</ul>
It also features advanced facilities such as:
<ul>
  <li>CT scan and MRI</li>
  <li>Pathology labs</li>
  <li>Modern operation theaters</li>
  <li>24/7 emergency services</li>
  <li>ICUs, NICUs, and HDUs</li>
</ul><br>

<strong>Academic Programs</strong><br>
GMC offers:<br>
<ul>
  <li>MBBS program (5.5 years including internship)</li>
  <li>B.Sc. Nursing</li>
  <li>PCL Nursing</li>
  <li>Other paramedical courses</li>
</ul>
Future plans include starting postgraduate MD/MS programs.<br><br>

<strong>Faculty and Teaching Methodology</strong><br>
The college has experienced faculty and promotes:
<ul>
  <li>Interactive learning</li>
  <li>Problem-based learning (PBL)</li>
  <li>Case discussions</li>
  <li>Clinical rotations</li>
  <li>Seminars and continuous assessments</li>
</ul><br>

<strong>International Student Hub</strong><br>
GMC is popular among Indian and international students due to:
<ul>
  <li>Proximity to India</li>
  <li>Affordable fees</li>
  <li>English as the medium of instruction</li>
  <li>Support for visas, accommodation, and cultural integration</li>
</ul><br>

<strong>Hostel and Student Facilities</strong><br>
GMC offers:
<ul>
  <li>Separate hostels for boys and girls</li>
  <li>Mess facilities</li>
  <li>Internet and study areas</li>
  <li>Recreational and gym facilities</li>
  <li>Cultural and sports events</li>
</ul><br>

<strong>Research and Development</strong><br>
GMC promotes:
<ul>
  <li>Student and faculty research through R&D Cell</li>
  <li>Training in research methodology</li>
  <li>Participation in national and international conferences</li>
  <li>Clinical and community-based research</li>
</ul><br>

<strong>Community Outreach and Social Responsibility</strong><br>
GMC organizes:
<ul>
  <li>Health camps and check-ups</li>
  <li>Awareness programs</li>
  <li>Vaccination drives</li>
</ul>
The college also partners with local government and NGOs.<br><br>

<strong>Admission Process</strong><br>
Admission to MBBS is via:
<ul>
  <li>Medical Education Commission (MEC) exam in Nepal</li>
  <li>NEET-UG for Indian students</li>
  <li>10+2 with Physics, Chemistry, and Biology</li>
</ul><br>

<strong>Life in Pokhara</strong><br>
Studying at GMC offers the unique benefit of living in Pokhara, known for:
<ul>
  <li>Lakes and mountain views</li>
  <li>Peaceful and supportive academic environment</li>
  <li>Modern amenities and natural beauty</li>
</ul>
`,
  collegename: "Gandaki Medical College Teaching Hospital and Research Center",
  established: null, // Research needed for specific establishment year
  collegetype: "Private", // Assuming private, but needs verification
  location: "Suburban",
  approval: "Nepal Medical Council (NMC)",
  address: "Pokhara, Nepal",
  state: "Gandaki Province", //added state
  city: "Pokhara",
  affiliatedby: "Tribhuvan University",
  collegecategory: "Medical",
  pdf: Gandakimedicalclgteachinghospital,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "5.5 years (including a 1-year internship)",
    tuitionFee: "57,40,625/-", // Research needed for specific tuition data
   },
   {
    course: "B.Sc. Nursing",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "PCL Nursing",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   {
    course: "Paramedical Courses",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
   // Adding room for future courses based on description
   {
    course: "MD/MS",
    branch: null, // Research needed for specific branch data
    totalSeat: null, // Research needed for specific seat data
    courseDuration: null, // Research needed for specific duration data
    tuitionFee: null, // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: null, // Research needed for official website
  mail: null, // Research needed for official email
  image1: "https://flyfuture.in/admin/services/1658570811.jpg",
  image2:
   "https://www.collegenp.com/uploads/2018/03/Gandaki-Medical-College.jpg", // Image URLs or base64 strings would need to be added
 },
 {
  id: "13",
  universityDescription: `<strong>Devdaha Medical College and Teaching Hospital (DMCTH) – A Comprehensive Overview</strong><br>
<br>
Devdaha Medical College and Teaching Hospital (DMCTH) is a prominent institution located in the serene and culturally rich city of Butwal, in the Rupandehi district of Nepal. Established with the aim of addressing the growing need for quality medical education and advanced healthcare services in the region, DMCTH stands as a beacon of excellence in medical sciences. The college is affiliated with Kathmandu University and recognized by the Nepal Medical Council (NMC), which ensures its curriculum and standards meet national and international expectations.<br>
<br>
<strong>Vision and Mission</strong><br>
Devdaha Medical College's vision is to produce competent, compassionate, and ethical medical professionals who are capable of meeting the healthcare needs of society. The mission encompasses not only delivering world-class education but also providing comprehensive healthcare services and engaging in research that advances medical knowledge.<br>
<br>
<strong>Academic Programs</strong><br>
DMCTH offers the Bachelor of Medicine and Bachelor of Surgery (MBBS) program, which is the cornerstone of its academic offerings. The MBBS program spans five and a half years, including a one-year compulsory internship. The curriculum is designed to integrate basic medical sciences with clinical disciplines, and it incorporates problem-based learning, community-based education, and evidence-based practices.<br>
<ul>
  <li>First two years: Anatomy, Physiology, Biochemistry, Microbiology, Pathology, Pharmacology, and Community Medicine</li>
  <li>Third year onwards: Internal Medicine, Surgery, Pediatrics, Obstetrics and Gynecology, Psychiatry, Orthopedics, Ophthalmology, ENT</li>
</ul>
The medium of instruction is English, and the college places a strong emphasis on practical skills and clinical exposure.<br>
<br>
<strong>Faculty and Teaching Methodology</strong><br>
DMCTH boasts a dedicated team of faculty members with diverse specializations and international exposure. These experienced professionals use a mix of modern teaching methodologies including:<br>
<ul>
  <li>Lectures</li>
  <li>Group discussions</li>
  <li>Seminars</li>
  <li>Hands-on clinical practice</li>
  <li>Simulations</li>
  <li>Digital learning tools</li>
</ul>
Continuous assessments include internal exams, OSCEs, case presentations, and practical demonstrations.<br>
<br>
<strong>Teaching Hospital and Clinical Facilities</strong><br>
The college has a fully functional teaching hospital with over 300 beds offering:<br>
<ul>
  <li>General Medicine</li>
  <li>Surgery</li>
  <li>Pediatrics</li>
  <li>Gynecology and Obstetrics</li>
  <li>Orthopedics</li>
  <li>Psychiatry</li>
  <li>Dermatology</li>
  <li>ENT</li>
  <li>Ophthalmology</li>
  <li>Anesthesiology</li>
  <li>Emergency Medicine</li>
</ul>
Facilities include operation theaters, ICUs, pathology labs, dialysis unit, and radiology services (X-ray, ultrasound, CT scans).<br>
<br>
<strong>Infrastructure and Campus</strong><br>
The DMCTH campus is peaceful and academically conducive. Key infrastructure includes:<br>
<ul>
  <li><strong>Lecture Halls:</strong> Spacious, air-conditioned, and equipped with audiovisual aids</li>
  <li><strong>Laboratories:</strong> Anatomy, Physiology, Biochemistry, Pathology, Microbiology, and Pharmacology labs</li>
  <li><strong>Library:</strong> Well-stocked with books, journals, and e-resources</li>
  <li><strong>Hostels:</strong> Separate for boys and girls with modern amenities</li>
  <li><strong>Cafeteria & Recreation:</strong> Hygienic meals and sports/common room facilities</li>
  <li><strong>Transportation:</strong> College buses available</li>
</ul>
<br>
<strong>International Students and Diversity</strong><br>
The college welcomes students from India, Bangladesh, Bhutan, and other neighboring countries. Advantages include:<br>
<ul>
  <li>Proximity to home</li>
  <li>Affordable fee structure</li>
  <li>NMC-recognized degree (eligible for FMGE/NEXT)</li>
</ul>
<br>
<strong>Community Engagement and Outreach</strong><br>
DMCTH organizes:<br>
<ul>
  <li>Medical camps</li>
  <li>Health awareness programs</li>
  <li>School health visits</li>
</ul>
These activities give students practical experience and promote public health.<br>
<br>
<strong>Research and Innovation</strong><br>
DMCTH fosters a research-friendly environment with:<br>
<ul>
  <li>Scientific studies by students and faculty</li>
  <li>Paper presentations and journal publications</li>
  <li>Participation in conferences</li>
</ul>
<br>
<strong>Student Life and Extracurricular Activities</strong><br>
The college supports holistic student development through:<br>
<ul>
  <li>Clubs and societies</li>
  <li>Sports and cultural festivals</li>
  <li>Debates and symposiums</li>
  <li>Mentorship, counseling, and career guidance</li>
</ul>
<br>
<strong>Career Prospects and Future Opportunities</strong><br>
Graduates are prepared for:<br>
<ul>
  <li>Postgraduate studies in Nepal and abroad</li>
  <li>Careers in hospitals, research, NGOs, and government services</li>
</ul>
Recognized by WHO, graduates can take exams like USMLE (USA), PLAB (UK), FMGE (India), etc.<br>
<br>
<strong>Fee Structure and Admissions</strong><br>
DMCTH offers a transparent and affordable fee structure. Admissions are based on:<br>
<ul>
  <li>Academic qualification</li>
  <li>Entrance exam performance</li>
  <li>Interview and selection process under Kathmandu University and MEC guidelines</li>
</ul>
`,
  collegename: "Devdaha Medical College and Teaching Hospital",
  established: null, // Research needed for specific establishment year
  collegetype: "Private", // Assuming private, but needs verification
  location: "Suburban",
  approval: "Nepal Medical Council (NMC)",
  address: "Butwal, Rupandehi District, Nepal",
  state: "Lumbini Province", //added state
  city: "Butwal",
  affiliatedby: "Kathmandu University",
  collegecategory: "Medical",
  pdf: Devdahamedicalclg,
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "5.5 years (including a 1-year internship)",
    tuitionFee: "53,77,000/-", // Research needed for specific tuition data
   },
  ],
  cutoffdata: [], // Research needed for cutoff data
  website: null, // Research needed for official website
  mail: null, // Research needed for official email
  image1:
   "https://nepalisearchengine.com/storage/files/np/863/069ffdb11791bc2ad3bcac0ff02ce5a8.png", // Image URLs or base64 strings would need to be added
  image2:
   "https://radicaleducation.in/wp-content/uploads/2024/05/Devdaha-medical-College.jpg", // Image URLs or base64 strings would need to be added
 },
 {
  id: "14",
  collegename: "B.P. Koirala Institute of Health Sciences (BPKIHS)",
  established: "1993-01-18",
  collegetype: "Public",
  location: "Dharan, Nepal",
  approval: "WHO & Nepal Medical Council (NMC)",
  address: "Dharan, Sunsari, Eastern Region, Nepal",
  state: "Sunsari",
  city: "Dharan",
  affiliatedby: "Autonomous",
  collegecategory: "Medical",
  pdf: BPKoiralaInstitute, // You can attach a PDF file reference here if available
  universityDescription: `B.P. Koirala Institute of Health Sciences (BPKIHS) was established on January 18, 1993 and subsequently upgraded as an autonomous Health Sciences University on October 28, 1998. Named after Bisheshwar Prasad Koirala, a visionary leader of Nepal, the institute is a leading example of Indo-Nepal cooperation. It aims to produce socially responsible and competent health professionals while offering high-quality healthcare and research. <br/><br/>
  
Located in Eastern Nepal, BPKIHS operates through a teaching district concept and provides services to Primary Health Care Centers, District Hospitals, and Zonal Hospitals. <br/><br/>
  
<strong>Why Choose BPKIHS?</strong><br/>
- WHO & NMC Approved College<br/>
- Listed among the top medical colleges for Indian students<br/>
- English language curriculum<br/>
- Affordable tuition fee<br/>
- Excellent hostel and accommodation for foreign students<br/>
- Globally recognized MBBS degree<br/><br/>

<strong>Rankings:</strong><br/>
- 8th in Nepal<br/>
- 4837 in World Ranking<br/>
- Recognized by NMC (India) and WHO<br/>`,

  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "5.5 years (including internship)",
    tuitionFee: "74,555/year", // Not mentioned
   },
  ],

  cutoffdata: [
   {
    year: "2023",
    neetScoreCutoff: "137",
    note:
     "NEET score of 137 or above required for direct admission. Below 137 must appear in MECEE-BL exam.",
   },
  ],

  website: null,
  mail: null,

  image1:
   "https://www.hamrodoctor.com/image.php?src=/uploads/hospitals/580c869210590.jpg&w=1000",
  image2:
   "https://cmsnepal.edu.np/wp-content/uploads/2018/06/final-logo-01.png",

  admissionEligibility: `There are two categories:<br/><br/>
  <strong>1. Foreign Students Appearing in MECEE-BL-2023:</strong><br/>
  Students who qualified NEET in 2021-2022-2023 but scored below 137 must sit for the MECEE-BL exam.<br/><br/>

  <strong>2. Foreign Students Not Appearing in MECEE-BL-2023:</strong><br/>
  Those with NEET score 137 or above can apply directly. Must have passed 10+2 with 50% marks in each of Physics, Chemistry, and Biology.`,

  contactPerson: {
   name: "Dr. Prashant Agrawal",
   designation: "Director",
   contact: ["+91-9650865123", "+91-9319214789"],
  },

  bankDetails: [
   {
    bankName: "NIC ASIA BANK LIMITED DHARAN BRANCH",
    beneficiaryName: "B.P.KOIRALA INSTITUTE OF HEALTH SCIENCES, DHARAN NEPAL",
    swiftCode: "NICENPKA",
    accountNumber: "2341014805524014",
   },
   {
    bankName: "SUNRISE BANK LIMITED, DHARAN BRANCH",
    beneficiaryName: "B.P.KOIRALA INSTITUTE OF HEALTH SCIENCES, DHARAN NEPAL",
    swiftCode: "SRBLNPKA",
    accountNumber: "00310251477018",
   },
   {
    bankName: "NEPAL SBI BANK LIMITED, DHARAN BRANCH",
    beneficiaryName: "B.P.KOIRALA INSTITUTE OF HEALTH SCIENCES, DHARAN NEPAL",
    swiftCode: "NSBINPKA",
    accountNumber: "19025240200022",
   },
  ],
 },
 {
  id: "15",
  collegename: "Birat Medical College (BMC)",
  established: null, // Not provided
  collegetype: "Private",
  location: "Morang, Budhiganga-2, Biratnagar, Nepal",
  approval: "WHO, MCI (Medical Council of India), NMC (Nepal Medical Council)",
  address: "Morang, Budhiganga-2, Biratnagar, Nepal",
  state: "Morang",
  city: "Biratnagar",
  affiliatedby: "Kathmandu University",
  collegecategory: BiratMedicalCollegeFeestructure,
  pdf: BiratMedicalCollegeFeestructure,

  universityDescription: `Birat Medical College (BMC) is a premier institution located in the Eastern Region of Nepal. It is the first private medical college under a government university in the Kathmandu Valley. With a 550-bedded multi-specialty hospital, state-of-the-art infrastructure, and modern facilities, it offers quality education and healthcare. The college is affiliated with Kathmandu University and recognized by WHO, MCI, and NMC. It provides excellent academic exposure through practical works, guest lectures, and research opportunities. <br/><br/>

<strong>Why Choose Birat Medical College?</strong><br/>
- 550-bedded Multi-Specialty Hospital<br/>
- WHO, MCI, NMC Recognized<br/>
- Affiliated to Kathmandu University<br/>
- Air-conditioned library, clean hostels, hygienic canteen<br/>
- Separate hostels for boys and girls<br/>
- Modern teaching pedagogy & experienced faculty<br/>`,

  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "5.5 years (including internship)",
    tuitionFee: "USD 75,000 (in 3 equal installments, excluding hostel & mess)",
   },
  ],

  cutoffdata: [
   {
    year: "2023",
    neetScoreCutoff: "137",
    note:
     "NEET score of 137 or above eligible for direct admission. Below 137 must qualify MECEE-BL.",
   },
  ],

  website: null,
  mail: null,

  image1: "https://www.piceeducare.com/images/30/jpg", // You can update with image URL if available
  image2:
   "https://5.imimg.com/data5/SELLER/Default/2020/12/KX/XJ/AV/119701179/birat-medical-college-biratnagar-nepal-fees-mci-approval-direct-admission-500x500.jpg",

  admissionEligibility: `There are two categories:<br/><br/>
  <strong>1. Foreign Students Appearing in MECEE-BL-2023:</strong><br/>
  NEET qualified (2021-2023) with score below 137 must appear and qualify MECEE-BL.<br/><br/>
  <strong>2. Foreign Students Not Appearing in MECEE-BL:</strong><br/>
  Those with NEET score 137 or above can apply directly. Must have passed 10+2 with 50% marks in Physics, Chemistry, and Biology.`,

  admissionProcess: [
   "Step 1: Submit the application form with required documents (10+2 marksheet, 10th marksheet, NEET admit card, NEET scorecard, ID proof, photo, application fee of INR 5000).",
   "Step 2: College verifies eligibility and issues provisional offer letter.",
   "Step 3: Pay INR 5,00,000 as booking amount.",
   "Step 4: Complete admission process through MEC.",
  ],

  contactPerson: {
   name: "Dr. Prashant Agrawal",
   designation: "Director",
   contact: ["+91-9650865123", "+91-9319214789"],
  },

  bankDetails: [
   {
    bankName: "Nepal SBI Bank Ltd, Kathmandu / State Bank of India",
    beneficiaryName: "Biratnagar Aspatal Pvt. Ltd., Biratnagar, Nepal",
    accountNumber: "23125240200382",
    swiftCode: "NSBINPKAXXX",
    internalSwiftCode: "AAMNEPALXXX",
    branchName: "Bargachi",
    branchCode: "231",
    ifscCode: "SBIN0004430 or SBININBB136",
    address: "Biratnagar, Nepal",
    transferMode: "FX-OUL Remit to Nepal (for SBI only)",
    purpose: "College Fee Payment",
   },
  ],

  additionalNotes: [
   "NRs 15,000/- charged per subject for university re-exam.",
   "NRs 5,000/- for internal re-exam if paper not cleared.",
   "Hostel is compulsory until final year board exam.",
   "Electricity charges extra for personal appliances.",
   "Refundable Security Deposit of NRs 100,000/- at admission.",
   "Pre-booking fee of INR 10,00,000 is non-refundable unless admission denied due to MEC/BMC rules.",
  ],
 },
 {
  id: "16",
  universityDescription: `Chitwan Medical College (CMC), located in Bharatpur, Nepal, is affiliated with Tribhuvan University. Established in 1993, it was initiated by the International Society for Medical Education Pvt. Ltd. It is Nepal’s first ISO-certified medical college and operates a 750-bed teaching hospital. CMC offers world-class education in fields like medicine, dentistry, public health, nursing, and allied sciences. It is recognized by MCI (India), SMC (Sri Lanka), GMC (UK), and ECFMG (USA). With top-notch infrastructure, experienced global faculty, and excellent patient flow, CMC provides a comprehensive academic and clinical environment for aspiring medical professionals.`,

  collegename: "Chitwan Medical College Pvt. Ltd.",
  established: "1993",
  collegetype: "Private",
  location: "Bharatpur-10, Chitwan, Nepal",
  approval: "MCI, SMC, GMC (UK), ECFMG (USA), ISO Certified",
  address: "Bharatpur-5, Kailashnagar, Chitwan, Nepal",
  state: "Bagmati Province",
  city: "Bharatpur",
  affiliatedby: "Tribhuvan University",
  collegecategory: "Medical",

  courses: [
   {
    course: "MBBS",
    branch: "General Medicine",
    totalSeat: "Not Specified",
    courseDuration: "5.5 Years",
    tuitionFee: "58,50,500/-",
   },
   {
    course: "MD",
    branch: "General Medicine",
    totalSeat: "Not Specified",
    courseDuration: "3 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
   {
    course: "BDS",
    branch: "Dental Surgery",
    totalSeat: "Not Specified",
    courseDuration: "5 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
   {
    course: "BSc Nursing",
    branch: "Nursing",
    totalSeat: "Not Specified",
    courseDuration: "4 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
   {
    course: "BSc MLT",
    branch: "Medical Laboratory Technology",
    totalSeat: "Not Specified",
    courseDuration: "4 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
   {
    course: "BPharm",
    branch: "Pharmacy",
    totalSeat: "Not Specified",
    courseDuration: "4 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
   {
    course: "BSc MIT",
    branch: "Medical Imaging Technology",
    totalSeat: "Not Specified",
    courseDuration: "4 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
   {
    course: "BPH",
    branch: "Public Health",
    totalSeat: "Not Specified",
    courseDuration: "4 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
   {
    course: "BN",
    branch: "Nursing",
    totalSeat: "Not Specified",
    courseDuration: "3 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
   {
    course: "MSc Clinical Microbiology",
    branch: "Microbiology",
    totalSeat: "Not Specified",
    courseDuration: "2 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
   {
    course: "MPH",
    branch: "Public Health",
    totalSeat: "Not Specified",
    courseDuration: "2 Years",
    tuitionFee: "Contact College for Fee Structure",
   },
  ],

  cutoffdata: [
   {
    seattype: "Foreign Quota",
    counsellingtype: "MECEE-BL",
    category: "NEET Qualified (Score < 137)",
    domicilecondition: "Not Required",
    round1rank2022: "Not Applicable",
    round2rank2022: "Not Applicable",
   },
   {
    seattype: "Foreign Quota",
    counsellingtype: "Direct Admission (via NEET)",
    category: "NEET Qualified (Score ≥ 137)",
    domicilecondition: "Not Required",
    round1rank2022: "Not Applicable",
    round2rank2022: "Not Applicable",
   },
  ],

  website: "", // You can update if known
  mail: "", // You can update if known
  pdf: ChitwanMedicalclg,
  image1:
   "https://careermudhra.com/wp-content/uploads/chitwan-medical-college-bharatpur.jpg", // Replace with S3 or local path
  image2:
   "https://media.licdn.com/dms/image/v2/C4E0BAQG_19dqyJtCWw/company-logo_200_200/company-logo_200_200/0/1649788315909?e=2147483647&v=beta&t=YX70t31jojgKy4M9bZl9A5pdEoSNCIr9FHcN7ccVRTM", // Replace with S3 or local path
 },
 {
  id: "17",
  universityDescription:
   "<p><strong>Karnali Academy of Health Sciences (KAHS)</strong>, established in 2011 by the Government of Nepal, is a premier institution located in the remote and mountainous region of Jumla. It aims to address the acute shortage of health professionals in the Karnali region and improve healthcare services in underserved areas. The academy has been offering a range of medical education and training programs with a focus on community-based learning and rural healthcare development.</p><p>KAHS is committed to producing skilled medical professionals capable of serving in rural and remote areas. Its educational philosophy emphasizes social accountability, inclusiveness, and quality education. The academy is equipped with modern facilities and operates a teaching hospital that serves as a major healthcare provider for the region. With plans to expand academic offerings including MBBS and nursing programs, KAHS plays a vital role in transforming healthcare and education in Karnali.</p>",
  collegename: "Karnali Academy of Health Sciences (KAHS), Jumla",
  established: "2011",
  collegetype: "Public",
  location: "Jumla, Karnali Province",
  approval: "Nepal Medical Council (NMC)",
  address: "Jumla, Karnali Province, Nepal",
  state: "Karnali Province",
  city: "Jumla",
  affiliatedby: "Karnali Academy of Health Sciences",
  collegecategory: "Medical",
  pdf: Karnali,
  courses: [
   {
    course: "MBBS",
    courseLevel: "Undergraduate",
    duration: "5.5 years",
    tuitionFee: "Rs. 38,00,000",
    eligibility:
     "10+2 or equivalent with Physics, Chemistry, Biology, and minimum 50% marks; NEET/entrance exam qualification required",
    entranceExam: "KAHS Entrance Exam / NEET (for Indian students)",
   },
  ],
  cutoffdata: [
   {
    year: "2024",
    category: "General",
    cutoff: "65%",
   },
   {
    year: "2023",
    category: "General",
    cutoff: "62%",
   },
  ],
  website: "https://kahs.edu.np",
  mail: "info@kahs.edu.np",
  image1:
   "https://sancharkarmi.com/uploads/news/images/487810518Karnali-health.jpeg",
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTv0sAoUuA0O4zsfNR2zKwwo_e7nCitw2vT_w&s",
 },
 {
  id: "18",
  collegename: "Manipal Pokhara College of Medical Sciences (MPCOMS)",
  established: "",
  collegetype: "Private",
  location: "Pokhara-16, Kaski 33700, Nepal",
  approval:
   "Nepal Medical Council (NMC), Medical Council of India (MCI), World Health Organization (WHO)",
  address: "Deep Heights, Pokhara 16, Kaski 33700, Nepal",
  state: "Gandaki",
  city: "Pokhara",
  affiliatedby: "Kathmandu University (KU)",
  collegecategory: "Medical",
  pdf: ManipalPokharaCollegeofMedicalScience,
  courses: [
   {
    course: "MBBS",
    courseDuration: "5.5 years",
    tuitionFee: "74,70,000",
    courseFees: {
     SAARC: "USD 75,000",
     OtherInternational: "USD 90,000",
    },
    installments: [
     {
      year: "1st Year",
      amount: "USD 25,000",
     },
     {
      year: "2nd Year",
      amount: "USD 30,000",
     },
     {
      year: "3rd Year",
      amount: "USD 30,000",
     },
    ],
   },
  ],
  cutoffdata: {
   NEET: {
    eligibleScore: "137",
    validYears: "2021, 2022, 2023",
    note:
     "Above 137 – direct admission through NEET; Below 137 – must appear in MECEE-BL-2023",
   },
  },
  website: "",
  mail: "",
  image1:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTg4zAniMDyKO38wdtJy0FF5YW36p-AtO29Rg&s",
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwWf276bUNrPJOtUS3B3dJhqjxdfT2MucTgA&s",
  universityDescription:
   "<p>Manipal Pokhara College of Medical Sciences (MpCOMS), located in Pokhara-16, Kaski, Nepal, is a premier private medical college affiliated to Kathmandu University. The college boasts a 550-bedded multi-specialty hospital with state-of-the-art infrastructure. It is listed in the World Health Organization (WHO) and recognized by the Medical Council of India (MCI) and Nepal Medical Council (NMC). The college provides advanced teaching pedagogy, research-based learning, and modern medical training.</p><p>The campus includes well-equipped lecture halls, seminar rooms, laboratories, and facilities like an air-conditioned library, hostels, hygienic canteen, and separate hostels for boys and girls. The institution is known for its experienced faculty and practical-based learning approach.</p>",
  feeDetails: {
   refundableDeposits: {
    cautionDeposit: "INR 62,500",
    messDeposit: "INR 9,375",
   },
   registrationFees: {
    KU: "INR 23,438 or actual",
    NepalMedicalCouncil: "INR 3,125 or actual",
   },
   internalExamFee: "INR 15,625 (Annual)",
   hostelFees: {
    roomOneTime: "INR 12,500",
    annualFee: "INR 86,250 (Single Occupancy)",
   },
   annualMessAdvance: "INR 93,750",
   lmsFee: "INR 6,250 per year",
   insurance: "INR 3,875 per year",
  },
  admissionProcess: [
   "Step 1: Submit the Application Form with required documents including 10+2 and 10th marksheets, NEET UG-2023 Score Card & Admit Card, passport-size photo, ID proof and application fee of INR 5000.",
   "Step 2: Receive a provisional offer letter upon verification.",
   "Step 3: Pay booking amount of INR 5,00,000 to confirm seat.",
   "Step 4: Complete the admission process via MEC with college support.",
  ],
  specialNote:
   "<p>Pre-booking amount of INR 10,00,000 is non-refundable except in cases where MEC or the college cancels admission. All financial transactions must be done through the authorized bank account of the college.</p>",
  bankDetails: {
   accountTitle: "Manipal Education and Medical Group Nepal Pvt Ltd",
   accountNumber: "241252402000002",
   swiftCode: "NSBINPKA",
   bankName: "Nepal SBI Bank Ltd",
   branch: "Manipal Extension Counter, Phulbari-11, Pokhara",
  },
  contact: {
   person: "Dr Prashant Agrawal (Director)",
   phoneIndia: "+91-9650865123, +91-9319214789",
  },
  admissionEligibility: [
   "Must have scored at least 50% in PCB (Physics, Chemistry, Biology) in 10+2 or equivalent.",
   "Must have qualified NEET UG in 2021, 2022, or 2023.",
   "Below NEET score of 137 must appear for MECEE-BL 2023.",
   "Above NEET score of 137 can apply directly.",
  ],
 },
 {
  id: "19",
  universityDescription: `<strong>Universal College of Medical Sciences and Teaching Hospital (UCMS) – Overview</strong><br><br>

<strong>About UCMS</strong><br>
<ul>
  <li>Established in 1998 and affiliated with Tribhuvan University (TU).</li>
  <li>Recognized by the Nepal Medical Council (NMC) and National Medical Commission (India).</li>
  <li>First private medical college in Nepal affiliated with Tribhuvan University.</li>
  <li>Situated in Ranigaon, Bhairahawa, Siddharthanagar 32900, Nepal.</li>
</ul><br>

<strong>Academic Programs</strong><br>
<ul>
  <li>Offers undergraduate and postgraduate courses in Medicine, Dentistry, Nursing, and Paramedical Sciences.</li>
  <li>Curriculum designed as per Tribhuvan University and Medical Education Commission (MEC) norms.</li>
</ul><br>

<strong>Infrastructure and Facilities</strong><br>
<ul>
  <li>Hi-tech classrooms equipped with audio-visual aids and air conditioning.</li>
  <li>Ten spacious lecture halls with modern facilities.</li>
  <li>Department-specific libraries along with a centralized library stocked with books, journals, and digital resources.</li>
  <li>24/7 internet and Wi-Fi access across the campus.</li>
  <li>Separate hostel facilities for boys and girls with full amenities and security.</li>
  <li>Cafeteria serving hygienic food.</li>
</ul><br>

<strong>Teaching Hospital</strong><br>
<ul>
  <li>Multispecialty hospital attached for clinical training and patient care exposure.</li>
  <li>Rotational internship during final year within hospital departments.</li>
</ul><br>

<strong>Admission Eligibility</strong><br>
<ul>
  <li>Minimum 50% marks in 10+2 or equivalent with PCB subjects.</li>
  <li>Must have cleared NEET UG (score ≥ 137) for Indian students.</li>
  <li>Students with valid entrance scores of their home country may apply directly.</li>
</ul><br>

<strong>Admission Process</strong><br>
<ol>
  <li>Submit application with required documents (10th, 12th marksheets, NEET card, passport/ID, photos, etc.).</li>
  <li>Receive a provisional offer letter upon eligibility verification.</li>
  <li>Deposit INR 5,00,000 as booking amount to confirm admission.</li>
  <li>Complete formal admission process through MEC with UCMS guidance.</li>
</ol><br>

<strong>MBBS Fee Structure for Indian/International Students (2023–24)</strong><br>
<ul>
  <li>Total Tuition Fee: USD 75,000 (Payable in 3 equal installments)</li>
  <li>Special SAARC Package: USD 60,000</li>
  <li>Installments: USD 25,000 + USD 25,000 + USD 25,000 (approx. INR 55,00,000)</li>
  <li>Hostel & Mess Fee: INR 8,000/month (excluded from tuition)</li>
  <li>Miscellaneous Fee (application, registration): As per university rules</li>
</ul><br>

<strong>Bank Details</strong><br>
<ul>
  <li>Bank Name: Kumari Bank Limited</li>
  <li>Account Name: ULAS & R Pvt Ltd</li>
  <li>SWIFT Code: KMBLNPKA</li>
  <li>Account Number: 2020245734800001</li>
  <li>Branch: Bhairahawa, Nepal (Branch Code: 202)</li>
</ul><br>

<strong>Why UCMS?</strong><br>
<ul>
  <li>Well-structured curriculum aligned with international standards.</li>
  <li>State-of-the-art infrastructure and clinical training facilities.</li>
  <li>Globally recognized degrees, especially by MCI (India) and NMC (Nepal).</li>
  <li>Affordable fee structure and SAARC-specific packages.</li>
</ul>
`,
  collegename:
   "Universal College of Medical Sciences and Teaching Hospital (UCMS)",
  established: "1998",
  collegetype: "Private",
  location: "Nepal",
  approval: "Nepal Medical Council (NMC), National Medical Commission (India)",
  address: "Ranigaon, Bhairahawa, Siddharthanagar 32900, Nepal",
  state: "Lumbini Province",
  city: "Siddharthanagar",
  affiliatedby: "Tribhuvan University (TU)",
  collegecategory: "Medical",
  pdf: UniversalCollegeOfMedicalSciences, // Replace with actual import variable
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine, Bachelor of Surgery",
    totalSeat: null, // Data not provided
    courseDuration: "5.5 years (including 1-year internship)",
    tuitionFee: "USD 75,000 (Standard) / USD 60,000 (SAARC Special Package)",
   },
   {
    course: "Postgraduate Programs",
    branch: null,
    totalSeat: null,
    courseDuration: null,
    tuitionFee: null,
   },
   {
    course: "Paramedical Courses",
    branch: null,
    totalSeat: null,
    courseDuration: null,
    tuitionFee: null,
   },
   {
    course: "Nursing & Dentistry",
    branch: null,
    totalSeat: null,
    courseDuration: null,
    tuitionFee: null,
   },
  ],
  cutoffdata: [], // Add NEET cutoff or MEC entrance cutoff if available
  website: null, // Official website not mentioned in source
  mail: null, // Official email not mentioned in source
  image1: "https://ucms.edu.np/media/images/ucms-about.original.jpg", // Sample image (Replace as needed)
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ-pIeYvfkB08UZ8PJR8kCklyxuclapY3-8kQ&s",
 },
];
